import TriplePointTakeoverLogo from './TriplePointTakeoverLogo'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import TriplePointTakeoverCampaignHeader from './TriplePointTakeoverCampaignHeader'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'

function TriplePointTakeoverSearchBanner() {
  const [tier] = useCurrentLoyaltyTier()

  return <Group fullWidth direction="horizontal" verticalAlign="center" horizontalAlign="center">
    <TriplePointTakeoverCampaignHeader
      logo={<CSSBreakpoint min="tablet"><TriplePointTakeoverLogo size="medium" /></CSSBreakpoint>}
      mobileCompactSubtitle
      textColour={`tier-${tier}-contrast`}
      titleVariant="heading3"
      viewOffersTo="/triple-points"
    />
  </Group>
}

export default TriplePointTakeoverSearchBanner
